<template>
  <modal-card title="Create Contact" fixed padding @close="$emit('close')">
    <v-fade-transition>
      <div class="success-message" v-if="createdContact">
        <v-icon color="primary">check</v-icon>
        <h4 class="mb-5">"{{ contactName }}" has been added!</h4>

        <template v-if="!returnContact">
          <v-btn color="appMain" @click="openContact">
            Go to {{ contactName }}
          </v-btn>
          <p class="mb-1 mt-1 font-weight-bold">or</p>
        </template>

        <v-btn color="appMain" @click="clearForm"> Add Another Contact </v-btn>
      </div>
    </v-fade-transition>

    <contact-form
      ref="contactForm"
      class="pa-6 pt-4"
      v-show="!createdContact"
      modal
      :returnContact="returnContact"
      :search="search"
      :disabled="!!createdContact"
      :editableFields="editableFields"
      @created="onContactCreate"
    />

    <template v-slot:actions>
      <portal-target name="createContactAction" />
    </template>
  </modal-card>
</template>

<script>
import { mapGetters } from 'vuex';
import ContactForm from '@/views/contacts/components/ContactForm';

export default {
  name: 'ContactCreateModal',
  components: {
    ContactForm,
  },
  props: {
    returnContact: Boolean,
    search: String,
    editableFields: Array,
  },
  data() {
    return {
      createdContact: null,
    };
  },
  computed: {
    ...mapGetters(['profilePid']),
    contactName() {
      return this.createdContact?.name;
    },
  },
  methods: {
    onContactCreate(contact) {
      this.createdContact = contact;
      this.$emit('created', contact);
    },

    openContact() {
      const { con_id } = this.createdContact;
      if (!con_id) return;

      this.$emit('close');

      if (this.profilePid) {
        this.$router.push({
          name: 'portal-contact',
          params: { contactId: con_id },
        });
      } else {
        this.$router.push({
          name: 'contact',
          params: { id: con_id },
        });
      }
    },

    clearForm() {
      this.$refs.contactForm.clearData();
      this.createdContact = null;
    },
  },
};
</script>

<style lang="less">
.success-message {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .v-icon {
    font-size: 80px;
  }
}
</style>
